import { render, staticRenderFns } from "./actFemaleRank.vue?vue&type=template&id=776d9924&scoped=true"
import script from "./actFemaleRank.vue?vue&type=script&lang=js"
export * from "./actFemaleRank.vue?vue&type=script&lang=js"
import style0 from "./actFemaleRank.vue?vue&type=style&index=0&id=776d9924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776d9924",
  null
  
)

export default component.exports